import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import Alert from '../Alert';
import { ajaxFeedbackTags } from '../redux/FeedbackRedux';

class TagsSection extends React.Component {
      constructor(props) {
            super(props);
            this.handleChange = this.handleChange.bind(this);
            this.state = {is_open: false};
      }

      handleOpenChange(event) {
            event.preventDefault();
            this.setState({
                  is_open: !this.state.is_open,
            });
      }

      handleChange(selectedTags) {
            var tags = []
            for (var tag in selectedTags) {
                  tags.push(selectedTags[tag].value);
            }


            this.props.dispatch(ajaxFeedbackTags(this.props.feedback.feedback_id, tags));
      }

      render() {
            var options = [];
            for (var tag in this.props.tags) {
                  if (this.props.tags[tag].is_active != 0) {
                        options.push({ value: "" + this.props.tags[tag].id, label: this.props.tags[tag].label });
                  }
            }

            var defaultvals = []
            for (var i in this.props.feedback.feedback_tags) {
                  if (this.props.feedback.feedback_tags[i].is_active == 1) {
                        defaultvals.push(options.find(element => element.value == this.props.feedback.feedback_tags[i].tags_id));
                  }
            }

            return (
                  <div className="card-body pb-4 border-top tag-section">
                        <Alert alert={this.props.alert} location={'tags'} />
                        <div className="d-flex align-items-center mb-2">
                              <h4 className='mb-0' data-toggle="tooltip" data-title={ __('Categorizes Feedbacks for easy labeling and search-ability')}>{__('Tags')}</h4>
                              {!defaultvals || defaultvals?.length < 1 &&
                                    <div className="ml-2">
                                          {!this.state.is_open &&
                                                <span className="btn btn-sm btn-primary toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="far fa-plus"></i>
                                                </span>
                                          }
                                          {this.state.is_open &&
                                                <span className="btn btn-sm btn-primary btn-primary-alt toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="far fa-times"></i>
                                                </span>
                                          }
                                    </div>
                              }
                        </div>

                        <div className="row tags">
                              <div className="col-md-12">
                                    {(this.props.current_user && (this.state.is_open || defaultvals.length > 0)) &&
                                          <Select className="react-select-container w-100 " classNamePrefix="react-select" isMulti value={defaultvals} onChange={this.handleChange} options={options} placeholder={__('Select')} />
                                    }
                                    {(!this.props.current_user && (this.state.is_open || defaultvals.length > 0)) &&
                                          <Select className="react-select-container w-100" classNamePrefix="react-select" isDisabled={true} isMulti value={defaultvals} onChange={this.handleChange} options={options} placeholder={__('Select')} />
                                    }
                              </div>
                        </div>
                  </div>
            );
      }
}

function mapStateToProps(state) {
      return { tag_state: state.tag_state, tags: state.feedback_detail.business.tags, feedback: state.feedback_detail, alert: state.alert.alert }
}

export default connect(mapStateToProps)(TagsSection)
